import {SideNavItem} from '../models/side-nav-item';
import {Authorize} from '../../../../auth/common/authorize-map';

export const adminNavItems: SideNavItem[] = [
    {
        title: 'CASES',
        icon: 'assignment',
        visible: true,
        route: ['/cases'],
        authorize: Authorize.NonAllocator,
        children: [
            {
                title: 'Case Dashboard',
                icon: 'note_add',
                visible: true,
                route: ['/dashboard'],
                authorize: Authorize.NonAllocator
            },
            {
                title: 'Case Directory',
                icon: 'note_add',
                visible: true,
                route: ['/cases/case-directory'],
                authorize: Authorize.NonAllocator
            },
            {
                title: 'Add New Case',
                icon: 'note_add',
                visible: true,
                route: ['/cases/new'],
                authorize: Authorize.NonAllocator
            },
            {
                title: 'Advanced Search',
                icon: 'note_add',
                visible: true,
                route: ['/cases/search'],
                authorize: Authorize.NonAllocator
            },
            {
                title: 'Manage Post Dispatch Cases',
                icon: 'note_add',
                visible: true,
                route: ['/cases/post-dispatch'],
                authorize: Authorize.Admins
            },
            {
                title: 'Send Case to Adopters',
                icon: 'note_add',
                visible: true,
                route: ['/donors/adopt-case'],
                authorize: Authorize.AdoptionProcess
            }
        ]
    },
    {
        title: 'AGENCIES',
        icon: 'business',
        visible: true,
        route: ['/agencies'],
        authorize: Authorize.NonAllocator,
        children: [
            {
                title: 'Agency Directory',
                icon: 'note_add',
                visible: true,
                route: ['/agencies'],
                authorize: Authorize.Admins
            },
            {
                title: 'Add New Agency',
                icon: 'note_add',
                visible: true,
                route: ['/agencies/new'],
                authorize: Authorize.CreateAgencies
            },
            {
                title: 'Manage my Agency',
                icon: 'note_add',
                visible: true,
                authorize: Authorize.AgencyAdmin
            }
        ]
    },
    {
        title: 'DONORS',
        icon: 'card_giftcard',
        visible: true,
        route: ['/donors'],
        authorize: Authorize.Admins,
        children: [
            {
                title: 'Add New Donor',
                icon: 'note_add',
                visible: true,
                route: ['/donors/new'],
                authorize: Authorize.Admins
            },
            {
                title: 'Advanced Search',
                icon: 'note_add',
                visible: true,
                route: ['/donors/search'],
                authorize: Authorize.Admins
            }
        ]
    },
    {
        title: 'DONATIONS',
        icon: 'attach_money',
        visible: true,
        route: ['/donations'],
        authorize: Authorize.Admins,
        children: [
            {
                title: 'Manage Donations Batches',
                icon: 'note_add',
                visible: true,
                route: ['/donations'],
                authorize: Authorize.Admins
            },
            {
                title: 'New Batch Payment',
                icon: 'note_add',
                visible: true,
                route: ['/donations/new-batch'],
                authorize: Authorize.Admins
            }
        ]
    },
    {
        title: 'CAMPAIGNS',
        icon: 'campaign',
        visible: true,
        route: ['/campaigns'],
        authorize: Authorize.Campaigns,
        children: [
            {
                title: 'Campaign Overview',
                icon: 'note_add',
                visible: true,
                route: ['/campaigns/overview']
            },
            {
                title: 'Manage Campaigns',
                icon: 'note_add',
                visible: true,
                route: ['/campaigns/manage']
            },
            {
                title: 'Add New Campaign Allocation',
                icon: 'note_add',
                visible: true,
                route: ['/campaigns/allocations/new']
            }
        ]
    },
    {
        title: 'ALLOCATORS',
        icon: 'badge',
        visible: true,
        route: ['/allocators'],
        authorize: Authorize.AllocatorWorkingPage,
        children: [
            {
                title: 'Distribute Allocations',
                icon: 'route',
                visible: true,
                route: ['/campaigns/allocations/distribute'],
                authorize: Authorize.ManageAllocators
            },
            {
                title: 'Manage Allocators',
                icon: 'route',
                visible: true,
                route: ['/allocators/manage'],
                authorize: Authorize.ManageAllocators
            },
            {
                title: 'Manage Allocation Dollars',
                icon: 'route',
                visible: true,
                route: ['/allocators/working-page'],
                authorize: Authorize.AllocatorWorkingPage
            }
        ]
    },
    {
        title: 'REPORTS',
        icon: 'analytics',
        visible: true,
        route: ['/reports'],
        authorize: Authorize.NonAllocator,
        children: [
            {
                title: 'Adopters Report',
                icon: 'note_add',
                route: ['/reports/adopters-report'],
                visible: true,
                authorize: Authorize.Admins
            },
            {
                title: 'Agency Contacts Report',
                icon: 'note_add',
                route: ['/reports/agency-contacts-report'],
                visible: true,
                authorize: Authorize.AgencyContactsReport
            },
            {
                title: 'Agency Payment Report',
                icon: 'note_add',
                route: ['/reports/bulk-agency-payment-report'],
                visible: true,
                authorize: Authorize.BulkAgencyPaymentReport
            },
            {
                title: 'Thank You Letters',
                icon: 'note_add',
                route: ['/reports/thank-you-letters'],
                visible: true,
                authorize: Authorize.Admins
            }
        ]
    },
    {
        title: 'MANAGE USERS',
        icon: 'people',
        visible: true,
        route: ['/'],
        authorize: Authorize.CreateUsers,
        children: [
            {
                title: 'Add New Guest User',
                icon: 'note_add',
                visible: true,
                route: ['/users/new'],
                authorize: Authorize.CreateUsers
            },
            {
                title: 'Guest User Directory',
                icon: 'note_add',
                visible: true,
                route: ['/users/user-directory'],
                authorize: Authorize.NonAllocator
            }
        ]
    }
];
